import { LabelingStatus } from '@/api/LabelingNode/types'
import { LABELING_STATUS } from '@/api/LabelingNode/const'

export const ZoomBehavior = {
  ZOOM_IN: 'zoom_in',
  ZOOM_OUT: 'zoom_out',
} as const

export const AnnotationLabelingType = {
  ANOMALY_DETECTION: 'ANOMALY_DETECTION',
  SEGMENTATION: 'SEGMENTATION',
  CLASSIFICATION: 'CLASSIFICATION',
  OBJECT_DETECTION: 'OBJECT_DETECTION',
}

export const LABELING_COMPLETED_ITEMS: LabelingStatus[] = [LABELING_STATUS.FINISHED, LABELING_STATUS.COMPLETED]
export const REVIEW_COMPLETED_ITEMS: LabelingStatus[] = [LABELING_STATUS.REJECTED, LABELING_STATUS.COMPLETED]
